export const EDITABLE_CARD_FEATURE = 'cal-txp-editableCard';
export const EMAIL_DONATION_FEATURE = 'cal-txp-emailDonation';
export const INFERENCES_DSAT_FEATURE = 'cal-txp-inferencesDSAT';
